import React from 'react';
import { Text, Button, useColorModeValue } from '@chakra-ui/react';
import { MdVisibility } from 'react-icons/md';
import { buildChangePreview, getAuditDiffs, isLegacyAuditLog } from 'utils/auditFormat';

export default function AuditChangesCell({ log, onView }) {
  const muted = useColorModeValue('gray.500', 'gray.400');
  const diffs = getAuditDiffs(log);
  const legacy = isLegacyAuditLog(log);

  if (!diffs.length && !legacy) {
    return (
      <Text fontSize="xs" color={muted}>
        —
      </Text>
    );
  }

  return (
    <>
      <Text fontSize="xs" color={muted} noOfLines={1} mb={1}>
        {buildChangePreview(log)}
      </Text>
      <Button
        size="xs"
        variant="outline"
        leftIcon={<MdVisibility />}
        onClick={() => onView(log)}
      >
        Ver cambios
      </Button>
    </>
  );
}
